export const PUSH_UPDATE_CONTRACTOR_DEBT_STATES_UPDATED = 'PUSH_UPDATE_CONTRACTOR_DEBT_STATES_UPDATED'
export const PUSH_UPDATE_ACCOUNT_CONTRACTOR_BINDING_DISABLED = "PUSH_UPDATE_ACCOUNT_CONTRACTOR_BINDING_DISABLED"
export const PUSH_UPDATE_ACCOUNT_CONTRACTOR_BINDING_ENABLED = "PUSH_UPDATE_ACCOUNT_CONTRACTOR_BINDING_ENABLED"
export const PUSH_UPDATE_ACCOUNT_CONTRACTOR_BIND_REGISTER = "PUSH_UPDATE_ACCOUNT_CONTRACTOR_BIND_REGISTER"
export const PUSH_UPDATE_ACCOUNT_CONTRACTOR_BIND_UNREGISTER = "PUSH_UPDATE_ACCOUNT_CONTRACTOR_BIND_UNREGISTER"
export const SETTINGS_ORGANIZATION_ACCOUNT_UPDATE = "SETTINGS_ORGANIZATION_ACCOUNT_UPDATE"
export const ACCOUNT_PERMISSION_UPDATE = "ACCOUNT_PERMISSION_UPDATE"
